// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"743":"css/admin-app.6871","4717":"css/app.6871"}[chunkId] + ".css";
};